import { render, staticRenderFns } from "./DownloadVacation2.vue?vue&type=template&id=26632922"
import script from "./DownloadVacation2.vue?vue&type=script&lang=ts"
export * from "./DownloadVacation2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports